import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  expectedArrivalTime: () => faker.date.soon({ days: 14 }),
  groupName: () => faker.music.songName(),
  includeGroupNameInEmail: true,
  jobId: () => faker.string.uuid(),
  notifyVisitor: true,
  privateNotes: '',
  csv: '',

  afterCreate(groupInvite, server) {
    if (groupInvite.flow) return;

    const flow = server.schema.flows.all().models[0];

    groupInvite.update({ flow });
  },

  meetup: trait({
    afterCreate(groupInvite, server) {
      const flow = server.schema.flows.findOrCreateBy({ name: 'Meetup' });

      groupInvite.update({ flow });
    },
  }),

  interview: trait({
    afterCreate(groupInvite, server) {
      const flow = groupInvite.flow ?? server.schema.flows.findOrCreateBy({ name: 'Interview' });

      groupInvite.update({ flow });
    },
  }),

  withCsvData: trait({
    groupName: 'Those Meddling Kids',
    csv: `
      invitee_name,invitee_email,Character Classification,additional_guests,private_notes,property_notes,
      Scooby Doo,,Dog,0,Dogs do not have emails,,
      Norville Rogers,shaggy@thosemeddlingkids.team,Human,0,,,
      Fred Jones,fred@thosemeddlingkids.team,Human,0,,,
      Daphne Blake,daphne@thosemeddlingkids.team,Human,0,,,
      Velma Dinkley,velma@thosemeddlingkids.team,Human,0,,,
      Scrappy Doo,,Dog,0,Dogs do not have emails,,
      Bronson Stone,bronson@sheriff-stone.legal,Human,0,,,
      Fred Jones Sr.,,Human,0,,,`,
  }),

  withInvites: trait({
    afterCreate(groupInvite, server) {
      const { groupName, expectedArrivalTime, employee, flow, location } = groupInvite;

      server.createList('invite', 5, {
        groupInvite,
        groupName,
        expectedArrivalTime,
        employee,
        flow,
        location,
      });
    },
  }),
});
